import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Hide, Show } from '@dls/assets/icons';
import { TextLink, Modal, Text, Button, Spacing, PinInput } from '@dls/web';
import { Container, DataLoading, ErrorSlate } from '@geit/ui-components';
import { useState, useEffect, useMemo, useCallback } from 'react';
import styled from 'styled-components';
import '../../authentication/context/AuthenticationProvider.js';
import { VERIFY_OTP_FAILED_BLOCKED, MASK_LEFT_TIME, MASKING_MAX_TRIES_ERROR_EXPIRE_SECONDS, MASK_CURRENT_MODULE } from '../../authentication/helpers/constants.js';
import { formatLeftTime, getMaskToken, updateCurrentModule, updateMaskToken, removeMaskToken } from '../../authentication/helpers/masking.js';
import { formatFullName } from '../../authentication/helpers/format.js';
import useAppModule from '../../authentication/hooks/useAppModule.js';
import { useCurrentUser } from '../../authentication/hooks/useCurrentUser.js';
import 'qs';
import 'uuid';
import '../../authentication/navigate.js';
import useRefreshPage from '../../authentication/hooks/useRefreshPage.js';
import { useSendOtp, useVerifyOtp } from './hooks.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MaskLink = _ref => {
  let {
    onClick
  } = _ref;
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const {
    data,
    sendOtp,
    error,
    isLoading
  } = useSendOtp();
  const {
    verify,
    error: verifyError,
    isLoading: verifyLoading
  } = useVerifyOtp();
  const [show, setShow] = useState(false);
  const {
    user,
    refreshUser
  } = useCurrentUser();
  const {
    refreshPage
  } = useRefreshPage();
  const {
    appModule
  } = useAppModule();
  const [leftTime, setLeftTime] = useState(0);
  const [OTPVerifyError, setOTPVerifyError] = useState(false);
  const [OTPVerifyErrorMsg, setOTPVerifyErrorMsg] = useState("");
  useEffect(() => {
    setShow(checkToken());
  }, []);
  const temToken = useMemo(() => {
    return (data == null ? void 0 : data.token) || "";
  }, [data == null ? void 0 : data.token]);
  const leftTimeTimer = useCallback(leftTime2 => {
    if (leftTime2 > 0) {
      let curSecond = leftTime2;
      setLeftTime(curSecond);
      const t = window.setInterval(() => {
        curSecond -= 1;
        setLeftTime(curSecond);
        if (curSecond <= 0) {
          setLeftTime(0);
          setOTPVerifyError(false);
          sendOtp();
          sessionStorage.removeItem("MASK_LEFT_TIME");
          window.clearInterval(t);
        }
      }, 1e3);
    }
  }, []);
  useEffect(() => {
    if (verifyError && (verifyError == null ? void 0 : verifyError.message) && verifyError.message === VERIFY_OTP_FAILED_BLOCKED) {
      const now = /* @__PURE__ */new Date().getTime();
      const leftTime2 = sessionStorage.getItem(MASK_LEFT_TIME);
      if (leftTime2 && Number(leftTime2) > now) {
        return;
      }
      setLeftTime(MASKING_MAX_TRIES_ERROR_EXPIRE_SECONDS);
      sessionStorage.setItem(MASK_LEFT_TIME, String(now + MASKING_MAX_TRIES_ERROR_EXPIRE_SECONDS * 1e3));
      leftTimeTimer(MASKING_MAX_TRIES_ERROR_EXPIRE_SECONDS);
    }
  }, [verifyError]);
  useEffect(() => {
    const leftTime2 = sessionStorage.getItem(MASK_LEFT_TIME);
    const now = /* @__PURE__ */new Date().getTime();
    if (verifyError || leftTime2 && Number(leftTime2) > now) {
      setOTPVerifyError(true);
    } else {
      setOTPVerifyError(false);
    }
  }, [verifyError]);
  useEffect(() => {
    const maskLeftTime = sessionStorage.getItem(MASK_LEFT_TIME);
    const now = /* @__PURE__ */new Date().getTime();
    if (maskLeftTime) {
      if (Number(maskLeftTime) > now) {
        leftTimeTimer((Number(maskLeftTime) - now) / 1e3);
      } else {
        sessionStorage.removeItem(MASK_LEFT_TIME);
      }
    }
  }, [leftTimeTimer]);
  useEffect(() => {
    if (OTPVerifyError) {
      if (leftTime > 0 || verifyError && (verifyError == null ? void 0 : verifyError.message) === VERIFY_OTP_FAILED_BLOCKED) {
        setOTPVerifyErrorMsg("You have exceeded the limit for OTP attempts. Please try again in ".concat(formatLeftTime(leftTime), "."));
      } else if (verifyError && (verifyError == null ? void 0 : verifyError.status) === 500) {
        setOTPVerifyErrorMsg("Something went wrong, please try again later");
      } else {
        setOTPVerifyErrorMsg("Try again with a valid OTP");
      }
    } else {
      setOTPVerifyErrorMsg("");
    }
  }, [OTPVerifyError, leftTime, verifyError]);
  const checkToken = () => {
    const token = getMaskToken();
    const localCurModule = localStorage.getItem(MASK_CURRENT_MODULE);
    if (localCurModule && token) {
      if (localCurModule !== (appModule == null ? void 0 : appModule.moduleName)) {
        token.unMasking = false;
        updateCurrentModule();
        updateMaskToken(token);
        refreshUser();
      }
      if (token.token && token.unMasking) {
        return true;
      }
    }
    return false;
  };
  const refresh = () => {
    setShow(checkToken());
    refreshUser().then(() => {
      refreshPage();
    });
  };
  const handleClick = () => {
    onClick == null ? void 0 : onClick();
    if (show) {
      removeMaskToken();
      refresh();
    } else {
      const token = getMaskToken();
      if (token && token.token) {
        updateMaskToken(__spreadProps(__spreadValues({}, token), {
          unMasking: true
        }));
        refresh();
        updateCurrentModule(appModule == null ? void 0 : appModule.moduleName);
      } else {
        setOtpModalVisible(true);
        sendOtp(formatFullName(user.firstName, user.lastName));
      }
    }
  };
  const getUnmaskToken = otpValue => {
    if (otpValue && otpValue.length === 6 && leftTime === 0) {
      const payload = {
        otpCode: otpValue,
        token: temToken,
        mode: "Email"
      };
      verify(payload).then(res => {
        if (res) {
          const isTokenExpired = res.expiryAt ? /* @__PURE__ */new Date().getTime() < Number(res.expiryAt) : false;
          const token = {
            token: res.dataScreening,
            unMasking: isTokenExpired,
            expiryAt: res.expiryAt,
            tokentype: res.tokentype
          };
          updateCurrentModule(appModule == null ? void 0 : appModule.moduleName);
          updateMaskToken(token);
          refresh();
          setOtpModalVisible(false);
        }
      });
    }
  };
  const onClose = () => {
    setOtpModalVisible(false);
  };
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(SCMaskLinkContainer, {
      id: "page-masking-link",
      children: /* @__PURE__ */jsxs(SCTextLink, {
        onClick: handleClick,
        children: [/* @__PURE__ */jsx(TextLink.Icon, {
          icon: show ? Hide : Show
        }), /* @__PURE__ */jsx(TextLink.Text, {
          children: show ? "Hide details" : "Show details"
        })]
      })
    }), /* @__PURE__ */jsx(Modal, {
      visible: otpModalVisible,
      title: isLoading ? "" : error ? "Oops! Something went wrong" : "OTP verification",
      onClose,
      children: /* @__PURE__ */jsx(Modal.Content, {
        children: error ? /* @__PURE__ */jsxs(Fragment, {
          children: [/* @__PURE__ */jsx(Container, {
            children: /* @__PURE__ */jsx(Text, {
              children: "We\u2019re experiencing some technical difficulties, please try again later."
            })
          }), /* @__PURE__ */jsx(Container, {
            xs: 12,
            md: 3,
            className: "mt-3",
            children: /* @__PURE__ */jsx(Button, {
              text: "Ok, got it",
              onClick: onClose
            })
          })]
        }) : /* @__PURE__ */jsxs(DataLoading, {
          isLoading,
          children: [/* @__PURE__ */jsx(Container, {
            children: /* @__PURE__ */jsx(Text, {
              children: "An OTP verification is required to view this information. Please enter the OTP sent to you in your email below:"
            })
          }), /* @__PURE__ */jsxs(DataLoading, {
            isLoading: verifyLoading,
            children: [/* @__PURE__ */jsx(Spacing, {
              top: 2,
              children: /* @__PURE__ */jsx(SCOtpDiv, {
                children: /* @__PURE__ */jsx(PinInput, {
                  bgColor: "haze",
                  size: 6,
                  autoFocus: true,
                  onChange: getUnmaskToken,
                  digitsOnly: true,
                  error: OTPVerifyError
                })
              })
            }), /* @__PURE__ */jsx("div", {
              className: "d-flex justify-content-center mt-1",
              children: /* @__PURE__ */jsx(ErrorSlate, {
                errorMessages: OTPVerifyErrorMsg,
                setError: null
              })
            })]
          })]
        })
      })
    })]
  });
};
const SCMaskLinkContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n"])));
const SCTextLink = styled(TextLink)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
const SCOtpDiv = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n"])));
export { MaskLink as default };